module.exports = __webpack_public_path__ + "static/media/pm_hc_accuracy.d206277c.png";